import React, { useState } from "react";
import { Table, Input, Button, Popconfirm, Form } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import EditableCell from "../editableCell/EditableCell"; 

const TableJobTitles = ({ data, handleInputChange, handleDelete }) => {
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");

    const isEditing = (record) => record.key === editingKey;

    const edit = (record) => {
        form.setFieldsValue({ jtt_title: "", ...record });
        setEditingKey(record.key);
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();
            handleInputChange(key, row.jtt_title);
            setEditingKey("");
        } catch (err) {
            console.error("Error al guardar:", err);
        }
    };

    const cancel = () => {
        setEditingKey("");
    };

    const columns = [
        {
            title: "Id",
            dataIndex: "jtt_id",
            key: "jtt_id",
            align: "center",
        },
        {
            title: "Cargo",
            dataIndex: "jtt_title",
            key: "jtt_title",
            editable: true,
        },
        {
            title: "Acciones",
            key: "actions",
            align: "center",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <>
                        <Button onClick={() => save(record.jtt_id)} type="link">
                            Guardar
                        </Button>
                        <Button danger onClick={cancel} type="link">
                            Cancelar
                        </Button>
                    </>
                ) : (
                    <>
                        <Button disabled={editingKey !== ""} onClick={() => edit(record)} type="link">
                            Editar
                        </Button>
                            <Popconfirm title="¿Seguro que deseas eliminar este cargo?" onConfirm={() => handleDelete(record.jtt_id)} okText="Sí" cancelText="No">
                            <Button danger icon={<DeleteOutlined />} disabled={editingKey !== ""} />
                        </Popconfirm>
                    </>
                );
            },
        },
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    return (
        <Form form={form} component={false}>
            <Table
                className="custom-green-table"
                size="small"
                dataSource={data}
                columns={mergedColumns}
                pagination={{ pageSize: 10, position: ["bottomRight"] }}
                scroll={{ x: "max-content" }}
                components={{ body: { cell: EditableCell } }}
            />
        </Form>
    );
};

export default TableJobTitles;
